import { Data } from 'classes/data';

export const data = new Data();
